<template>
  <div class="learningRed"  >
      <commonHeader></commonHeader>
      <indexMapListRed></indexMapListRed>
  </div>
</template>
<script>
import indexMapListRed from "./../components/index-map-list-red.vue";
import commonHeader from "./../components/common-header.vue";
import cfg from "./../utils/config";
import L from "leaflet";

export default {
  name: "learningRed",
  data() {
    return {
      swipeable: "true",
      param: {}
    };
  },
  methods: {
    
    getCourseItem: function(obj) {
      if (obj) {
        this.param.rcom = true;
        this.param.page = 3;
      } else {
        this.param.rcom = "";
        this.param.page = 10;
      }
      // IndexApi.coursesItem(this.param, (ret, err) => {
      //   if (err) {
      //     console.log(err);
      //   } else {
      //     if (obj) {
      //       this.rcomData = ret.data;
      //     } else {
      //       this.courseData = ret.data;
      //     }
      //   }
      // });
    }
  },
  watch: {
    
  },
  mounted: function() {

  },
  components: {
    indexMapListRed,
    commonHeader
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/baseScss";
.mint-tabbar > .mint-tab-item.is-selected {
    background-color: #eaeaea;
    color: #E60202;
}
.learingIndex {
  text-align: center;
}
.learingFooter {
  color: $cl7;
  margin-top: 51px;
  .icon {
   
    display: block;
    font-size: 22px;
    margin-bottom: 3px;
  }
}
.common-header /deep/ .mint-header{
    position:absolute;
    width: 35px !important;
    height: 48px !important ;
    // top:33px !important;
}
.learningRed{
  height: 100%;
}

// #app  /deep/ .margintop{
//    margin-top: 0px !important;
// }

</style>



// WEBPACK FOOTER //
// src/module-red/index.vue